import { i18n } from '../translate/i18n';

const weekDayToText = dayNumber => {
  switch(dayNumber) {
    case 0:
      return i18n.t('weekDayToText.0')
    case 1:
      return i18n.t('weekDayToText.1')
    case 2:
      return i18n.t('weekDayToText.2')
    case 3:
      return i18n.t('weekDayToText.3')
    case 4:
      return i18n.t('weekDayToText.4')
    case 5:
      return i18n.t('weekDayToText.5')
    case 6:
      return i18n.t('weekDayToText.6')
    default:
      return i18n.t('weekDayToText.7')
  }
}


export default weekDayToText;
